const userServiceBaseUrl = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_USER_SERVICE}`;
export const GET_ROLE_AND_PRIVILEGES = userServiceBaseUrl + `/privileges`;
export const LOGIN_HISTORY = userServiceBaseUrl + `/login/history`;
export const GET_PREFERENCES = userServiceBaseUrl + "/preferences";
export const SET_PREFERENCES = userServiceBaseUrl + "/update/preferences";
export const GET_RBAC_DATA = userServiceBaseUrl + `/rbac-data`;
export const UPDATE_RBAC_DATA = userServiceBaseUrl + `/assign-privilege`;
export const UPDATE_USER_DATA = userServiceBaseUrl + `/update-user`;
export const GET_USERS_DATA = userServiceBaseUrl + `/user-details`;
export const UPDATE_PRIVILEGES = userServiceBaseUrl + `/update-privileges`;
